import t from '../translate';

// Category Types
export const INCIDENT = 'incident';
export const NEWS = 'news';
export const REPORT = 'report';
export const THREAT_LANDSCAPE_AI_REPORT = 'threat_landscape_ai_report';

export const CATEGORY_TYPES = [INCIDENT, NEWS, REPORT, THREAT_LANDSCAPE_AI_REPORT];

// Category Display Names
export const CATEGORY_DISPLAY_NAMES = {
  [INCIDENT]: t('non_targeted_alerts.category.incident'),
  [NEWS]: t('non_targeted_alerts.category.news'),
  [REPORT]: t('non_targeted_alerts.category.reports'),
  [THREAT_LANDSCAPE_AI_REPORT]: t('non_targeted_alerts.category.threat_landscape_ai_report')
};

// Activity Types (for incident filters)
export const DDOS = 'information-system-disruption';
export const RANSOMWARE = 'ransomware';
export const BREACH = 'breach';
export const DEFACE = 'defacement';
export const DATA_LEAK = 'data-leak';

export const ATTACK_TYPES = [DDOS, RANSOMWARE, BREACH, DEFACE, DATA_LEAK];

// Confidence Levels
export const CONFIDENCE_LEVELS = {
  25: t('confidence_levels.25'),
  50: t('confidence_levels.50'),
  75: t('confidence_levels.75'),
  100: t('confidence_levels.100')
};

export const CONFIDENCE_OPTIONS = [25, 50, 75, 100];

// Filter Field Names
export const FILTER_FIELDS = {
  TYPE: 'type',
  THREAT_ACTOR_ID: 'threat_actor_id',
  SECTOR: 'sector',
  COUNTRY: 'country',
  REGION: 'region',
  CONFIDENCE: 'confidence',
  CADENCE: 'cadence',
  SCOPE_TYPE: 'scope_type'
};
